@if (sortDirection() === 'asc') {
  <i class="fa fa-sort-asc"></i>
}
@if (sortDirection() === 'desc') {
  <i class="fa fa-sort-desc"></i>
}
@if (sortDirection() === '') {
  <i class="fa fa-unsorted"></i>
}
<ng-content></ng-content>
